import React, { useState } from 'react';
import { Lock, Shield, CheckCircle, AlertTriangle, Info, Camera, Upload, X, ChevronRight, Eye, EyeOff, HelpCircle, Calendar, User, Mail } from 'lucide-react';
export const AgeVerification = ({
  onClose
}) => {
  const [verificationStep, setVerificationStep] = useState('intro');
  const [showPassword, setShowPassword] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  return <section className="space-y-6 bg-white rounded-xl border border-gray-200 shadow-xl animate-in fade-in zoom-in duration-300" data-id="element-652">
      <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-653">
        <div className="flex items-center gap-2" data-id="element-654">
          <h2 className="text-lg font-bold text-gray-800" data-id="element-655">Age Verification</h2>
          <div className="text-xs px-2 py-0.5 bg-red-100 rounded-full text-red-600" data-id="element-656">
            Required
          </div>
        </div>
        <button className="text-sm text-pink-500 flex items-center gap-1" data-id="element-657">
          <HelpCircle size={14} data-id="element-658" />
          <span data-id="element-659">Help</span>
        </button>
      </div>
      {verificationStep === 'intro' && <div className="p-4" data-id="element-660">
          <div className="p-4 mb-4 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl border border-pink-200" data-id="element-661">
            <div className="flex items-center gap-3 mb-3" data-id="element-662">
              <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-full text-pink-500" data-id="element-663">
                <Shield size={24} data-id="element-664" />
              </div>
              <div data-id="element-665">
                <h3 className="text-lg font-bold text-gray-800" data-id="element-666">
                  Age Verification Required
                </h3>
                <p className="text-sm text-gray-600" data-id="element-667">
                  To access adult content, you must verify your age
                </p>
              </div>
            </div>
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2" data-id="element-668">
              <AlertTriangle size={18} className="text-red-500 mt-0.5 flex-shrink-0" data-id="element-669" />
              <p className="text-sm text-gray-700" data-id="element-670">
                This platform contains adult content that is only suitable for
                individuals who are at least 18 years of age or the legal age in
                your jurisdiction, whichever is higher.
              </p>
            </div>
          </div>
          <h3 className="font-medium mb-3 text-gray-800" data-id="element-671">
            Verification Options
          </h3>
          <div className="space-y-3" data-id="element-672">
            <button className="w-full p-3 bg-white rounded-lg border border-gray-200 hover:border-pink-500 transition flex items-center justify-between" onClick={() => setVerificationStep('id')} data-id="element-673">
              <div className="flex items-center gap-3" data-id="element-674">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full text-pink-500" data-id="element-675">
                  <Camera size={20} data-id="element-676" />
                </div>
                <div className="text-left" data-id="element-677">
                  <p className="font-medium text-gray-800" data-id="element-678">ID Verification</p>
                  <p className="text-xs text-gray-500" data-id="element-679">
                    Upload government-issued ID
                  </p>
                </div>
              </div>
              <ChevronRight size={18} className="text-gray-400" data-id="element-680" />
            </button>
            <button className="w-full p-3 bg-white rounded-lg border border-gray-200 hover:border-pink-500 transition flex items-center justify-between" onClick={() => setVerificationStep('credit')} data-id="element-681">
              <div className="flex items-center gap-3" data-id="element-682">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full text-pink-500" data-id="element-683">
                  <Lock size={20} data-id="element-684" />
                </div>
                <div className="text-left" data-id="element-685">
                  <p className="font-medium text-gray-800" data-id="element-686">
                    Credit Card Verification
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-687">
                    Verify with a valid credit card
                  </p>
                </div>
              </div>
              <ChevronRight size={18} className="text-gray-400" data-id="element-688" />
            </button>
            <button className="w-full p-3 bg-white rounded-lg border border-gray-200 hover:border-pink-500 transition flex items-center justify-between" onClick={() => setVerificationStep('selfie')} data-id="element-689">
              <div className="flex items-center gap-3" data-id="element-690">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full text-pink-500" data-id="element-691">
                  <User size={20} data-id="element-692" />
                </div>
                <div className="text-left" data-id="element-693">
                  <p className="font-medium text-gray-800" data-id="element-694">
                    Selfie Verification
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-695">
                    Take a selfie with your ID
                  </p>
                </div>
              </div>
              <ChevronRight size={18} className="text-gray-400" data-id="element-696" />
            </button>
          </div>
          <div className="mt-4 p-3 bg-gray-50 rounded-lg" data-id="element-697">
            <div className="flex items-center gap-2 mb-2" data-id="element-698">
              <Info size={16} className="text-blue-500" data-id="element-699" />
              <h4 className="font-medium text-gray-800" data-id="element-700">Why we verify</h4>
            </div>
            <p className="text-sm text-gray-700 mb-2" data-id="element-701">
              Age verification is required by law to ensure all users accessing
              adult content are of legal age. Your privacy and security are our
              top priorities.
            </p>
            <div className="space-y-1 text-sm" data-id="element-702">
              <div className="flex items-start gap-2" data-id="element-703">
                <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-704" />
                <p className="text-gray-700" data-id="element-705">
                  Your data is encrypted and secure
                </p>
              </div>
              <div className="flex items-start gap-2" data-id="element-706">
                <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-707" />
                <p className="text-gray-700" data-id="element-708">
                  We comply with privacy regulations
                </p>
              </div>
              <div className="flex items-start gap-2" data-id="element-709">
                <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-710" />
                <p className="text-gray-700" data-id="element-711">
                  Verification is a one-time process
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between" data-id="element-712">
            <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" onClick={onClose} data-id="element-713">
              Later
            </button>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-714">
              <Shield size={14} className="text-pink-500" data-id="element-715" />
              <span data-id="element-716">Your data is secure</span>
            </div>
          </div>
        </div>}
      {verificationStep === 'id' && <div className="p-4" data-id="element-717">
          <div className="flex items-center gap-2 mb-4" data-id="element-718">
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100" onClick={() => setVerificationStep('intro')} data-id="element-719">
              <X size={18} className="text-gray-500" data-id="element-720" />
            </button>
            <h3 className="font-bold text-gray-800" data-id="element-721">ID Verification</h3>
          </div>
          <p className="text-sm text-gray-700 mb-4" data-id="element-722">
            Please upload a clear photo of your government-issued ID (passport,
            driver's license, or national ID card).
          </p>
          <div className="space-y-4" data-id="element-723">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center" data-id="element-724">
              <Upload size={32} className="text-gray-400 mb-2" data-id="element-725" />
              <p className="text-sm font-medium mb-1 text-gray-800" data-id="element-726">
                Upload ID Front
              </p>
              <p className="text-xs text-gray-500 mb-3 text-center" data-id="element-727">
                JPG, PNG or PDF format (max 5MB)
              </p>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-sm text-white" data-id="element-728">
                Select File
              </button>
            </div>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center" data-id="element-729">
              <Upload size={32} className="text-gray-400 mb-2" data-id="element-730" />
              <p className="text-sm font-medium mb-1 text-gray-800" data-id="element-731">
                Upload ID Back
              </p>
              <p className="text-xs text-gray-500 mb-3 text-center" data-id="element-732">
                JPG, PNG or PDF format (max 5MB)
              </p>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-sm text-white" data-id="element-733">
                Select File
              </button>
            </div>
            <div className="p-3 bg-gray-50 rounded-lg space-y-2" data-id="element-734">
              <h4 className="font-medium text-gray-800" data-id="element-735">Requirements:</h4>
              <div className="space-y-1 text-sm" data-id="element-736">
                <div className="flex items-start gap-2" data-id="element-737">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-738" />
                  <p className="text-gray-700" data-id="element-739">
                    All four corners of the ID must be visible
                  </p>
                </div>
                <div className="flex items-start gap-2" data-id="element-740">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-741" />
                  <p className="text-gray-700" data-id="element-742">
                    Information must be clearly readable
                  </p>
                </div>
                <div className="flex items-start gap-2" data-id="element-743">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-744" />
                  <p className="text-gray-700" data-id="element-745">ID must not be expired</p>
                </div>
                <div className="flex items-start gap-2" data-id="element-746">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-747" />
                  <p className="text-gray-700" data-id="element-748">
                    No glare or shadows covering information
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-749">
              <input type="checkbox" id="terms" className="w-4 h-4 rounded bg-white border-gray-300 text-pink-500 focus:ring-pink-500" checked={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} data-id="element-750" />
              <label htmlFor="terms" className="text-sm text-gray-700" data-id="element-751">
                I confirm that I am at least 18 years old and agree to the{' '}
                <a href="#" className="text-pink-500" data-id="element-752">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" className="text-pink-500" data-id="element-753">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div className="flex items-center justify-between" data-id="element-754">
              <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" onClick={() => setVerificationStep('intro')} data-id="element-755">
                Back
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed" disabled={!termsAccepted} onClick={() => setVerificationStep('processing')} data-id="element-756">
                Submit for Verification
              </button>
            </div>
          </div>
        </div>}
      {verificationStep === 'credit' && <div className="p-4" data-id="element-757">
          <div className="flex items-center gap-2 mb-4" data-id="element-758">
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100" onClick={() => setVerificationStep('intro')} data-id="element-759">
              <X size={18} className="text-gray-500" data-id="element-760" />
            </button>
            <h3 className="font-bold text-gray-800" data-id="element-761">
              Credit Card Verification
            </h3>
          </div>
          <p className="text-sm text-gray-700 mb-4" data-id="element-762">
            We'll make a temporary $1.00 authorization (not a charge) to verify
            your age. This will disappear from your statement in a few days.
          </p>
          <div className="space-y-4" data-id="element-763">
            <div className="space-y-3" data-id="element-764">
              <div data-id="element-765">
                <label className="text-sm text-gray-700 mb-1 block" data-id="element-766">
                  Card Number
                </label>
                <div className="relative" data-id="element-767">
                  <input type="text" placeholder="1234 5678 9012 3456" className="w-full bg-white rounded-lg px-4 py-2 text-sm border border-gray-300 focus:border-pink-500 outline-none text-gray-800" data-id="element-768" />
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-769">
                    <Lock size={16} data-id="element-770" />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-771">
                <div data-id="element-772">
                  <label className="text-sm text-gray-700 mb-1 block" data-id="element-773">
                    Expiration Date
                  </label>
                  <input type="text" placeholder="MM/YY" className="w-full bg-white rounded-lg px-4 py-2 text-sm border border-gray-300 focus:border-pink-500 outline-none text-gray-800" data-id="element-774" />
                </div>
                <div data-id="element-775">
                  <label className="text-sm text-gray-700 mb-1 block" data-id="element-776">
                    CVV
                  </label>
                  <div className="relative" data-id="element-777">
                    <input type="text" placeholder="123" className="w-full bg-white rounded-lg px-4 py-2 text-sm border border-gray-300 focus:border-pink-500 outline-none text-gray-800" data-id="element-778" />
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-779">
                      <HelpCircle size={16} data-id="element-780" />
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-781">
                <label className="text-sm text-gray-700 mb-1 block" data-id="element-782">
                  Name on Card
                </label>
                <input type="text" placeholder="John Smith" className="w-full bg-white rounded-lg px-4 py-2 text-sm border border-gray-300 focus:border-pink-500 outline-none text-gray-800" data-id="element-783" />
              </div>
              <div data-id="element-784">
                <label className="text-sm text-gray-700 mb-1 block" data-id="element-785">
                  Date of Birth
                </label>
                <div className="relative" data-id="element-786">
                  <input type="text" placeholder="MM/DD/YYYY" className="w-full bg-white rounded-lg px-4 py-2 text-sm border border-gray-300 focus:border-pink-500 outline-none text-gray-800" data-id="element-787" />
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-788">
                    <Calendar size={16} data-id="element-789" />
                  </div>
                </div>
              </div>
            </div>
            <div className="p-3 bg-gray-50 rounded-lg" data-id="element-790">
              <div className="flex items-center gap-2 mb-2" data-id="element-791">
                <Shield size={16} className="text-green-500" data-id="element-792" />
                <h4 className="font-medium text-gray-800" data-id="element-793">Secure Processing</h4>
              </div>
              <p className="text-sm text-gray-700" data-id="element-794">
                Your card details are encrypted and processed securely. We use
                industry-standard security protocols and do not store your full
                card details.
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-795">
              <input type="checkbox" id="terms" className="w-4 h-4 rounded bg-white border-gray-300 text-pink-500 focus:ring-pink-500" checked={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} data-id="element-796" />
              <label htmlFor="terms" className="text-sm text-gray-700" data-id="element-797">
                I confirm that I am at least 18 years old and agree to the{' '}
                <a href="#" className="text-pink-500" data-id="element-798">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" className="text-pink-500" data-id="element-799">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div className="flex items-center justify-between" data-id="element-800">
              <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" onClick={() => setVerificationStep('intro')} data-id="element-801">
                Back
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed" disabled={!termsAccepted} onClick={() => setVerificationStep('processing')} data-id="element-802">
                Verify ($1.00 authorization)
              </button>
            </div>
          </div>
        </div>}
      {verificationStep === 'selfie' && <div className="p-4" data-id="element-803">
          <div className="flex items-center gap-2 mb-4" data-id="element-804">
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100" onClick={() => setVerificationStep('intro')} data-id="element-805">
              <X size={18} className="text-gray-500" data-id="element-806" />
            </button>
            <h3 className="font-bold text-gray-800" data-id="element-807">Selfie Verification</h3>
          </div>
          <p className="text-sm text-gray-700 mb-4" data-id="element-808">
            Please take a clear selfie of yourself holding your ID next to your
            face. This helps us verify that you are the ID holder.
          </p>
          <div className="space-y-4" data-id="element-809">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center" data-id="element-810">
              <Camera size={32} className="text-gray-400 mb-2" data-id="element-811" />
              <p className="text-sm font-medium mb-1 text-gray-800" data-id="element-812">
                Take a Selfie with ID
              </p>
              <p className="text-xs text-gray-500 mb-3 text-center" data-id="element-813">
                Make sure your face and ID are clearly visible
              </p>
              <div className="flex gap-2" data-id="element-814">
                <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-sm text-white" data-id="element-815">
                  Take Photo
                </button>
                <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" data-id="element-816">
                  Upload
                </button>
              </div>
            </div>
            <div className="p-3 bg-gray-50 rounded-lg space-y-2" data-id="element-817">
              <h4 className="font-medium text-gray-800" data-id="element-818">Requirements:</h4>
              <div className="space-y-1 text-sm" data-id="element-819">
                <div className="flex items-start gap-2" data-id="element-820">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-821" />
                  <p className="text-gray-700" data-id="element-822">
                    Your face must be clearly visible
                  </p>
                </div>
                <div className="flex items-start gap-2" data-id="element-823">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-824" />
                  <p className="text-gray-700" data-id="element-825">
                    Hold your ID next to your face
                  </p>
                </div>
                <div className="flex items-start gap-2" data-id="element-826">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-827" />
                  <p className="text-gray-700" data-id="element-828">Good lighting conditions</p>
                </div>
                <div className="flex items-start gap-2" data-id="element-829">
                  <CheckCircle size={14} className="text-green-500 mt-1" data-id="element-830" />
                  <p className="text-gray-700" data-id="element-831">No filters or editing</p>
                </div>
              </div>
            </div>
            <div className="p-3 bg-gray-50 rounded-lg" data-id="element-832">
              <div className="flex items-center gap-2 mb-2" data-id="element-833">
                <Info size={16} className="text-blue-500" data-id="element-834" />
                <h4 className="font-medium text-gray-800" data-id="element-835">
                  Why we need a selfie
                </h4>
              </div>
              <p className="text-sm text-gray-700" data-id="element-836">
                A selfie with your ID helps us confirm you're the actual person
                on the ID and prevents identity fraud. This keeps our platform
                safe for everyone.
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-837">
              <input type="checkbox" id="terms" className="w-4 h-4 rounded bg-white border-gray-300 text-pink-500 focus:ring-pink-500" checked={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} data-id="element-838" />
              <label htmlFor="terms" className="text-sm text-gray-700" data-id="element-839">
                I confirm that I am at least 18 years old and agree to the{' '}
                <a href="#" className="text-pink-500" data-id="element-840">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" className="text-pink-500" data-id="element-841">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div className="flex items-center justify-between" data-id="element-842">
              <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" onClick={() => setVerificationStep('intro')} data-id="element-843">
                Back
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed" disabled={!termsAccepted} onClick={() => setVerificationStep('processing')} data-id="element-844">
                Submit for Verification
              </button>
            </div>
          </div>
        </div>}
      {verificationStep === 'processing' && <div className="p-4" data-id="element-845">
          <h3 className="font-bold text-center mb-4 text-gray-800" data-id="element-846">
            Verification in Progress
          </h3>
          <div className="flex flex-col items-center p-4" data-id="element-847">
            <div className="w-20 h-20 rounded-full border-4 border-t-transparent border-pink-500 animate-spin mb-4" data-id="element-848"></div>
            <h3 className="text-lg font-bold mb-2 text-gray-800" data-id="element-849">
              Processing Your Verification
            </h3>
            <p className="text-sm text-gray-700 text-center mb-4" data-id="element-850">
              We're reviewing your information. This usually takes 5-10 minutes
              but may take up to 24 hours in some cases.
            </p>
            <div className="w-full p-3 bg-gray-50 rounded-lg mb-4" data-id="element-851">
              <div className="flex items-center gap-2 mb-2" data-id="element-852">
                <Info size={16} className="text-blue-500" data-id="element-853" />
                <h4 className="font-medium text-gray-800" data-id="element-854">
                  What happens next?
                </h4>
              </div>
              <div className="space-y-2 text-sm text-gray-700" data-id="element-855">
                <p data-id="element-856">1. Our system verifies your information</p>
                <p data-id="element-857">2. You'll receive a notification when complete</p>
                <p data-id="element-858">3. Once verified, you'll have full access to all content</p>
              </div>
            </div>
            <div className="flex items-center justify-between w-full" data-id="element-859">
              <button className="px-4 py-2 bg-gray-100 rounded-lg text-sm border border-gray-200 text-gray-700" onClick={onClose} data-id="element-860">
                Check Status Later
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-sm text-white" onClick={() => setVerificationStep('success')} data-id="element-861">
                Simulate Success
              </button>
            </div>
          </div>
        </div>}
      {verificationStep === 'success' && <div className="p-4" data-id="element-862">
          <div className="p-4 mb-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl border border-green-200" data-id="element-863">
            <div className="flex items-center gap-3" data-id="element-864">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full text-green-500" data-id="element-865">
                <CheckCircle size={24} data-id="element-866" />
              </div>
              <div data-id="element-867">
                <h3 className="text-lg font-bold text-gray-800" data-id="element-868">
                  Verification Successful
                </h3>
                <p className="text-sm text-gray-700" data-id="element-869">
                  Your age has been verified successfully
                </p>
              </div>
            </div>
          </div>
          <div className="p-3 bg-green-50 border border-green-200 rounded-lg flex items-start gap-2 mb-4" data-id="element-870">
            <CheckCircle size={18} className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-871" />
            <p className="text-sm text-gray-700" data-id="element-872">
              Congratulations! Your age has been verified. You now have full
              access to all content on the platform.
            </p>
          </div>
          <div className="space-y-3 mb-4" data-id="element-873">
            <div className="p-3 bg-gray-50 rounded-lg flex items-center justify-between" data-id="element-874">
              <div className="flex items-center gap-3" data-id="element-875">
                <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full text-green-500" data-id="element-876">
                  <User size={20} data-id="element-877" />
                </div>
                <div data-id="element-878">
                  <p className="font-medium text-gray-800" data-id="element-879">Age Verification</p>
                  <p className="text-xs text-gray-500" data-id="element-880">18+ verified</p>
                </div>
              </div>
              <div className="text-xs px-2 py-0.5 bg-green-100 rounded-full text-green-600" data-id="element-881">
                Complete
              </div>
            </div>
            <div className="p-3 bg-gray-50 rounded-lg flex items-center justify-between" data-id="element-882">
              <div className="flex items-center gap-3" data-id="element-883">
                <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full text-green-500" data-id="element-884">
                  <Shield size={20} data-id="element-885" />
                </div>
                <div data-id="element-886">
                  <p className="font-medium text-gray-800" data-id="element-887">
                    Identity Verification
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-888">Identity confirmed</p>
                </div>
              </div>
              <div className="text-xs px-2 py-0.5 bg-green-100 rounded-full text-green-600" data-id="element-889">
                Complete
              </div>
            </div>
          </div>
          <div className="p-3 bg-gray-50 rounded-lg mb-4" data-id="element-890">
            <div className="flex items-center gap-2 mb-2" data-id="element-891">
              <Info size={16} className="text-blue-500" data-id="element-892" />
              <h4 className="font-medium text-gray-800" data-id="element-893">
                Verification Details
              </h4>
            </div>
            <div className="space-y-2" data-id="element-894">
              <div className="flex items-center justify-between" data-id="element-895">
                <span className="text-sm text-gray-500" data-id="element-896">
                  Verification Method
                </span>
                <span className="text-sm text-gray-800" data-id="element-897">ID Verification</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-898">
                <span className="text-sm text-gray-500" data-id="element-899">Verification Date</span>
                <span className="text-sm text-gray-800" data-id="element-900">May 10, 2023</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-901">
                <span className="text-sm text-gray-500" data-id="element-902">
                  Verification Status
                </span>
                <span className="text-sm text-green-600" data-id="element-903">Approved</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-904">
                <span className="text-sm text-gray-500" data-id="element-905">Next Review</span>
                <span className="text-sm text-gray-800" data-id="element-906">Never</span>
              </div>
            </div>
          </div>
          <button className="w-full py-3 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white font-medium" onClick={onClose} data-id="element-907">
            Continue to Content
          </button>
          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-908">
            <Shield size={14} className="text-green-500" data-id="element-909" />
            <span data-id="element-910">Your account is now fully verified</span>
          </div>
        </div>}
    </section>;
};